import { render, staticRenderFns } from "./MyLuggage2.vue?vue&type=template&id=e9f632ba&scoped=true&"
import script from "./MyLuggage2.vue?vue&type=script&lang=js&"
export * from "./MyLuggage2.vue?vue&type=script&lang=js&"
import style0 from "./MyLuggage2.vue?vue&type=style&index=0&id=e9f632ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f632ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VProgressLinear,VTab,VTabItem,VTabs,VTabsItems})
